import { render, staticRenderFns } from "./HomeNewComponent.vue?vue&type=template&id=1a6d12be&scoped=true&"
import script from "./HomeNewComponent.vue?vue&type=script&lang=js&"
export * from "./HomeNewComponent.vue?vue&type=script&lang=js&"
import style0 from "./HomeNewComponent.vue?vue&type=style&index=0&id=1a6d12be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6d12be",
  null
  
)

export default component.exports